var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',_vm._l((_vm.company.languages),function(lng){return _c('b-tab-item',{key:lng,attrs:{"label":_vm.$t(`languages.${lng}`)}},[_c('b-input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder},on:{"input":_vm.onChange},model:{value:(_vm.data[lng]),callback:function ($$v) {_vm.$set(_vm.data, lng, $$v)},expression:"data[lng]"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }